import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

const VERTICAL_SPACING_MIN = 0;
const VERTICAL_SPACING_MAX = 250;

export function ItemVerticalSpacingOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemScaleX = useGetKeyFromActiveItem('scaleX');
  const itemYSpacing = useGetKeyFromTableItem('ySpacing');

  if (!activeItem || (activeItem && !('ySpacing' in activeItem)) || itemScaleX === undefined || itemYSpacing === undefined) {
    throw new Error('item doesnt have y spacing property');
  }

  const updateYSpacing = (ySpacing: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        ySpacing,
      },
      {
        undoable,
      }
    );
  };

  const onChangeValue = (updatedValue: number): void => {
    updateYSpacing(updatedValue / itemScaleX, false);
  };

  const onChangeEnded = (updatedValue: number): void => {
    updateYSpacing(updatedValue / itemScaleX);
  };

  return (
    <ContextualMenuSliderOptions
      id="y-spacing-slider"
      label={window.i18next.t('pmwjs_vertical_spacing')}
      value={Math.round(itemYSpacing * itemScaleX)}
      range={{
        min: VERTICAL_SPACING_MIN,
        max: VERTICAL_SPACING_MAX,
      }}
      transformDisplay={{
        min: VERTICAL_SPACING_MIN,
        max: VERTICAL_SPACING_MAX,
      }}
      onChange={onChangeValue}
      onChangeEnded={onChangeEnded}
    />
  );
}
